export default __webpack_public_path__ + "static/media/USDT.a6731ce5.svg";